<template>
    <div class="container">
        <div class="section" v-for="(item, index) in PCimgList" :key="index">
            <img :src="item">
            <div class="activityBox" v-if="activity.isShow && index == 0">
                <img class="activityImg" :src="activity.PCactiveImg">
            </div>
        </div>
        <!-- 阶段 -->
        <div class="section-main">
            <div 
                class="item" 
                v-for="(item, index) in PCstageList" :key="index" 
                v-on:mouseover="changeActive(index)" 
                v-on:mouseout="removeActive($event)"
            >
                <img :src="item">
            </div>
            <div 
                class="section-detail" 
                :style="{left: popX + '%',top: popY + 'PX'}" v-if="showDetail"
                v-on:mouseover="detailover()" 
                v-on:mouseout="removeActive()"
            >
                <img class="d-imgs" src="https://s21.lgstatic.com/growth/activity/20210316/1615895988394.png">
                <div class="title">{{sortStageList[activeIndex].title}} </div>
                <div class="d-item" v-for="(item, index) in sortStageList[activeIndex].detail" :key="index" >
                    <div class="d-title">
                        {{item.title}}
                    </div>
                    <div class="d-center">
                        <div class="d-name">
                            <img class="d-img" :src="iconImg">{{item.name}}
                        </div>
                        <div class="d-desc">
                            {{item.desc}}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="section" v-for="(item, index) in PCimgList1" :key="index">
            <img :src="item">
        </div>
        <button class="footer" @click="JumpFn">
            <img :src="PCfooterImg">
            <div class="iconBox" v-if="activity.isShow">
                <img class="icon" :src="activity.PCicon">
            </div>
        </button>
    </div>
</template>

<script>
import { handleJumpUrl } from '../../../uitl/getParam.js';
import List from './list';
import activity from '../../../common/activity';
let popTimer = null;
export default {
    data() {
        return {
            activity,
            iconImg:"https://s21.lgstatic.com/growth/activity/20210315/1615794992222.png",
            activeIndex:'',
            List:List,
            showDetail:false,
            popY:0,
            popX:0,
            "PCimgList":[],
            "PCstageList":[],
            "PCimgList1":[],
            "sortStageList":[],
            "PCfooterImg":"",
        }
    },
    mounted() {
        setTimeout(()=>{
            this.eduPlatTrack('WebView', { page_id: '1s2b'});
        },500)
        this.sortStageList = this.List.data.sortStageList
        this.PCimgList = this.List.data.PCimgList
        this.PCstageList = this.List.data.PCstageList
        this.PCimgList1 = this.List.data.PCimgList1
        this.PCfooterImg = this.List.data.PCfooterImg
    },
    methods: {
        JumpFn() {
            this.eduPlatTrack('WebButtonClick', {
                'page_id': '1s2b',
                'button_name': '领取详细课程大纲'
            });
            window.location.href = "https://t.lagou.com/aR95RvRxcY24B";
        },
        changeActive(i) { 
            clearTimeout(popTimer);
            this.showDetail = true;
            this.activeIndex = i
            if(i == 0 || i == 1) {
                this.popY = 650
            } else if (i == 2 || i == 3) {
                this.popY = 1300
            }
            if(i == 0 || i == 2) {
                this.popX = 40
            }else if (i == 1 || i == 3) {
                this.popX = 60
            }
        },
        removeActive($event){ 
            popTimer = setTimeout(() => {
                this.showDetail = false;
                this.popY = 0
                this.activeIndex = ''
            }, 300);
        },
        detailover() {
            if(this.showDetail) {
                clearTimeout(popTimer);
            }
        },
    },
}
</script>

<style lang="less" scoped>
.container {
    width: 100%;
    background-color: #eff6ff;
    margin: 0 auto;
    padding-bottom: 120PX;
}
.section {
    width: 100%;
    min-width: 1200PX;
    img {
        display: block;
        width: 100%;
    }
    .activityBox {
        position: absolute;
        top: 0;
        left: 50%;
        transform: translate(-50%);
        width: 950PX;
        height: 150PX;
    }
    .activityImg {
        display: block;
        float: right;
        width: 104PX;
        height: 133PX;
    }
}
.section-main {
    position: relative;
    // overflow: hidden;
    margin: 0PX auto 0;
    padding-top: 50PX;
    width: 1100PX;
    min-width: 1100PX;
    height: 1300PX;
    background-color: #eff6ff;
    .item {
        width: 530PX;
        float: left;
        margin-bottom: 40PX;
        img {
            display: block;
            width: 100%;
        }
    }
    .item:nth-child(1), .item:nth-child(3){
        margin-right: 40PX;
    }
    .section-detail {
        position: absolute;
        transform: translate(-50%);
        width: 1000PX;
        border-radius: 20PX;
        background-color: #fff;
        border: 1PX solid #105FE6;
        box-sizing: border-box;
        padding: 30PX;
        z-index: 999;
        .d-imgs {
            position: absolute;
            top: -17PX;
            left: 50%;
            transform: translate(-50%);
            width: 27PX;
        }
        .title {
            font-size: 26PX;
            text-align: center;
            padding: 0 0 12PX;
        }
        .d-item {
            width: 50%;
            box-sizing: border-box;
            margin: 10PX 0PX;
            float: left;
            display: flex;
            .d-title {
                width: 80PX;
                font-size: 20PX;
                color: #105FE6;
            }
            .d-center {
                flex: 1;
                padding-right: 8PX;
                .d-name {
                    font-size: 18PX;
                    color:#333;
                    font-weight: 500;
                    .d-img {
                        width: 3PX;
                        height: 20PX;
                        vertical-align: middle;
                        padding-right: 10PX;
                        margin-top: -2PX;
                    }
                }
                .d-desc {
                    font-size: 16PX;
                    color:#666;
                    padding-left: 15PX;
                }
            }
        }
    }
}
.footer {
    position: fixed;
    bottom: 0;
    z-index: 999;
    width: 100%;
    min-width: 1200PX;
    background-color:transparent;
    border: none;
    img {
        width: 100%;
        display: block;
    }
    .iconBox {
        position: absolute;
        top: -30PX;
        left: 50%;
        transform: translate(-50%);
        z-index: 9999;
        width: 940PX;
        .icon {
            float: right;
            width: 134PX;
        }
    }
}
</style>